import isSameDay from "date-fns/fp/isSameDay";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import formatDateRange from "@app/util/stackRank/formatDateRange";

const formatDrillDownDateRange = (dateRange: DateRange) =>
  formatDateRange(dateRange, isSameDay(dateRange.startDate, dateRange.endDate) ? "PPp" : "PPPP");

export default formatDrillDownDateRange;
